/**
 * Canonical hook for lens template queries.
 * Replaces duplicate inline LIST_LENS_TEMPLATES in LensCatalogPage + ConstellationPage.
 */

import { useQuery } from '@apollo/client/react';
import { gql } from '@apollo/client';

const LIST_LENS_TEMPLATES = gql`
  query ListLensTemplates($vertical: String, $constellation: String) {
    lensTemplates(vertical: $vertical, constellation: $constellation) {
      lensId
      name
      description
      phase
      safetyLevel
      verticals
      appliesToConstellation
      ruleCount
    }
  }
`;

export interface LensTemplate {
  lensId: string;
  name: string;
  description: string;
  phase: string;
  safetyLevel: string;
  verticals: string[];
  appliesToConstellation: boolean;
  ruleCount: number;
  version?: number;
}

interface ListLensTemplatesData {
  lensTemplates: LensTemplate[];
}

interface UseLensTemplatesOptions {
  vertical?: string;
  constellation?: string;
}

export function useLensTemplates(options: UseLensTemplatesOptions = {}) {
  const { data, loading, error, refetch } = useQuery<ListLensTemplatesData>(
    LIST_LENS_TEMPLATES,
    {
      variables: {
        vertical: options.vertical || undefined,
        constellation: options.constellation || undefined,
      },
    }
  );

  return {
    templates: data?.lensTemplates ?? [],
    loading,
    error,
    refetch,
  };
}
